(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactAddressDialogController', ContactAddressDialogController);

    ContactAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContactAddress', 'CountryState'];

    function ContactAddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ContactAddress, CountryState) {
        var vm = this;

        vm.contactAddress = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countrystates = CountryState.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.contactAddress.id !== null) {
                ContactAddress.update(vm.contactAddress, onSaveSuccess, onSaveError);
            } else {
                ContactAddress.save(vm.contactAddress, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:contactAddressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
